
<template>
  <div>
  <div class="cntnt" >

<div id="aiib" hidden>

    <h1 class="heading">  AIIB Project</h1>
    <p class="content">
    link
    </p>
  </div>
<div id="saubhagya">
  <b-row>
    <b-col cols="6">
        <h1 class="heading">সৌভাগ্য</h1>
    </b-col>
</b-row>
<p class="content">
<b-row>
  <b-col cols="12" class="iphone5font">
    <strong>(প্ৰধান মন্ত্ৰী সহজ বিজুলী হৰ ঘৰ যোঁজনা)</strong>
  </b-col>
</b-row>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <strong>লক্ষ্যসমূহ:</strong> দেশত সাৰ্বজনীনভাৱে ঘৰুৱা বৈদ্যুতিকৰণ সম্পন্ন কৰা।
  </b-col>
</b-row>
<strong>লক্ষ্য সম্পন্ন কৰাৰ তাৰিখ : </strong> ৩১ মাৰ্চ, ২০১৯
<br><br>
<strong>মূখ্য বৈশিষ্ট্যসমূহ:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
  <ol>
    <li>আঁচনিখনে নগৰ আৰু গ্ৰাম্য দুয়োটা অঞ্চলকেই সামৰি ল'ব।</li>
    <li>অসমত মুঠ ২৬.৪৫ লাখ পৰিয়ালক বৈদ্যুতিক সংযোগ প্ৰদান কৰা হ'ব। (গ্ৰাম্য: ২৪.৮০ লাখ; নগৰীয়া: ১.৬৫ লাখ)</li>
    <li>সৌভাগ্য আঁচনিৰ অধীনত সংযোগ প্ৰদান কৰাৰ বাবে এপিডিচিএল-এ "সংযোগ" নামৰ এটা নতুন মোবাইল এপ্ বিকশিত কৰিছে।</li>
    <li>সৌভাগ্য আঁচনিৰ অধীনৰ সকলো নতুন সংযোগ মোবাইল এপ্-ৰ জৰিয়তে মুকলি কৰা হ'ব।</li>
    <li>ম'বাইল এপটোত হিতাধিকাৰীসকলৰ লগতে নথিপত্ৰসমূহৰ ফটো তোলাৰ ব্যৱস্থা আছে।</li>
    <li>ম'বাইল এপটোৱে হিতাধিকাৰীসকলৰ ঘৰৰ জিপিএছ স্থানাংকও ধৰি ৰাখিব পাৰিব।</li>
    <li>বিনা কাগজে সংযোগ প্ৰক্ৰিয়া; কোনো ভৌতিক নথি পত্ৰ দাখিল কৰাৰ প্ৰয়োজন নাই।</li>
    <li>সংযোগৰ সময়ত কোনো মাচুল দিয়াৰ কৰাৰ প্ৰয়োজন নাই।</li>
  </ol>
</b-col>
</b-row>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <a target="_blank" href="https://saubhagya.gov.in/">সৌভাগ্য যোঁজনাৰ শেহতীয়া স্থিতিৰ বিষয়ে জানিবলৈ ইয়াত ক্লিক কৰক।</a>
  </b-col>
</b-row>
</p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
<div id="ipds">
  <b-row>
    <b-col cols="6">
      <h1 class="heading">আই.পি.দি.এচ.</h1>
    </b-col>

 </b-row>

<p class="content">
<strong>(সংহত শক্তি উন্নয়ন আঁচনি)</strong>
<br>
<strong>লক্ষ্যসমূহ:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>নগৰাঞ্চলত উপ-পৰিবহন আৰু বিতৰণ নেটৱৰ্ক শক্তিশালী কৰা।</li>
      <li>চহৰাঞ্চলত বিতৰণ ট্ৰেন্সফৰ্মাৰ/ফিডাৰ/গ্ৰাহকৰ মিটাৰ সংযোগ।</li>
      <li>বিতৰণ খণ্ড তথ্য প্ৰযুক্তি সক্ষমকৰণ আৰু বিতৰণ নেটৱৰ্ক শক্তিশালী কৰা।</li>
    </ol>
  </b-col>
</b-row>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    এই আঁচনিয়ে এ.টি. এণ্ড চি. লোকচান হ্ৰাস কৰা,
    তথ্য-প্ৰযুক্তি সক্ষম শক্তি একাউণ্টিং/অডিটিং প্ৰণালী স্থাপন, মিটাৰ যুক্ত ব্যৱহাৰৰ ওপৰত আধাৰিত বিল শক্তিৰ উন্নতি আৰু সংগ্ৰহ দক্ষতা উন্নত কৰাত সহায় কৰিব।
  </b-col>
</b-row>
<strong>বৰ্তমান স্থিতি: </strong>
<br>
প্ৰদান কৰা কাম:
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>নতুন উপ-আস্থান : ১৩ সংখ্যক।</li>
      <li>ক্ষমতা বৃদ্ধি আৰু অতিৰিক্ত ট্ৰেন্সফৰ্মাৰ: ৩৬ সংখ্যক। </li>
      <li>HT লাইন (৩৩ kV আৰু ১১ kV) : ৬১৬ CkM</li>
      <li>LT লাইন : ২১১ CkM</li>
      <li>এৰিয়েল বাণ্ড’লদ্‌ কেব'ল / আন্দাৰগ্ৰাউণ্ড: ২৩২২ CkM</li>
      <li>নতুন বিতৰণ ট্ৰেন্সফ’ৰ্মাৰ: ৫৯৬ সংখ্যক।</li>
      <li>গ্ৰাহকৰ মিটাৰ: ৬৮১৯০ সংখ্যক।</li>
    </ol>
  </b-col>
</b-row>
<a target="_blank" href="https://www.ipds.gov.in/Default.aspx">আই.পি.দি.এচ আঁচনিৰ শেহতীয়া স্থিতিৰ বিষয়ে জানিবলৈ ইয়াত ক্লিক কৰক।</a>
</p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
<div id="ddugjy">
  <b-row>
    <b-col cols="6">
    <h1 class="heading">দি.দি.ইউ.জি.জে.ৱাই.</h1>
    </b-col>
 </b-row>

 <p class="content">
   <strong>(দীনদয়াল উপাধ্যায় গ্ৰাম জ্যোতি যোঁজনা)</strong>
<br>
<strong>লক্ষ্যসমূহ:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>সকলো গাওঁক বৈদ্যুতিকৰণ প্ৰদান কৰা।</li>
      <li>যোগানৰ মানদণ্ড আৰু নিৰ্ভৰযোগ্যতা উন্নত কৰাৰ উপ-পৰিবহন আৰু বিতৰণ নেটৱৰ্কৰ উন্নয়ণ।</li>
      <li>লোকচান হ্ৰাস কৰিবলৈ মিটাৰ সংযোগ কৰণ।</li>
    </ol>
  </b-col>
</b-row>
<strong>বৰ্তমান স্থিতি:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>৩১/১২/২০১৭ তাৰিখে ২৫৩৭২ সংখ্যক লোকপিয়ল গাঁৱত বিদ্যুতসংযোগ কৰা হৈছে।</li>
      <li>উপ-পৰিবহন আৰু বিতৰণ নেটৱৰ্ক উন্নয়নৰ কাম চলি আছে।</li>
      <li>প্ৰতিটো স্তৰত(ইন্‌পুট পইণ্ট, ফিদাৰ আৰু বিতৰণ ট্ৰেন্সফ’ৰ্মাৰ) মিটাৰ সংযোগৰ কাম চলি আছে।</li>
    </ol>
  </b-col>
</b-row>
<a target="_blank" href="http://www.ddugjy.gov.in/">DDUGJY আঁচনিৰ শেহতীয় স্থিতিৰ বিষয়ে জানিবলৈ ইয়াত ক্লিক কৰক।

</a>
 </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
<div id="uday">
  <b-row>
    <b-col cols="6">
      <h1 class="heading">উদয় </h1>
    </b-col>
 </b-row>
 <p class="content">
   <strong>(উজ্বল জ্যোতি এচ্যুৰেন্স যোঁজনা)</strong>
<br>
<strong>লক্ষ্যসমূহ:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
      (ৰাজ্যিক শক্তি বিতৰণ কোম্পানীবোৰৰ(DISCOMs) কাৰ্যকৰী আৰু বিত্তীয় দক্ষতা উন্নত কৰা।)
  </b-col>
</b-row>
<br>
<strong>বৰ্তমান স্থিতি:</strong>
<b-row>
  <b-col col cols="12" sm="12" md="12" lg="12">
    <ol>
      <li>০৪/০১/২০১৭ তাৰিখে ভাৰত চৰকাৰ, অসম চৰকাৰ আৰু এপিডিচিএলৰ মাজত ত্ৰিপাক্ষিক বুজাবুজি চুক্তি স্বাক্ষৰিত হৈছিল। (বুজাবুজি চুক্তি চাবলৈ ইয়াত ক্লিক কৰক)</li>
      <li>বুজাবুজি চুক্তি অনুসৰি, এপিডিচিএল-এ নিম্নলিখিত পথ অনুসৰি ২০১৯-২০ বৰ্ষৰ ভিতৰত এ.টি. এণ্ড চি লোকচান আৰু এ.চি.এছ.-এ.আৰ.আৰ. ব্যৱধান হ্ৰাস কৰাৰ প্ৰস্তাৱ দিছে:</li>
    </ol>
  </b-col>
</b-row>
<strong>AT&C Losses:</strong>
<table border class="tableWidth">
  <tr>
    <th>2016-17</th>
    <th>2017-18</th>
    <th>2018-19</th>
    <th>2019-20</th>
  </tr>
  <tr>
    <td>19.00%</td>
    <td>17.75%</td>
    <td>16.10%</td>
    <td>15.00%</td>
  </tr>
</table>
<strong>ACS-ARR Gap:</strong>
<table border class="tableWidth">
  <tr>
    <th>2016-17</th>
    <th>2017-18</th>
    <th>2018-19</th>
    <th>2019-20</th>
  </tr>
  <tr>
    <td>Rs. 0.66</td>
    <td>Rs. 0.43</td>
    <td>Rs. 0.19</td>
    <td>Rs. 0.05</td>
  </tr>
</table>
<br>
<a target="_blank" href="https://www.uday.gov.in/state.php?id=19&code=assam">উদয় আঁচনিৰ শেহতীয়া স্থিতিৰ বিষয়ে জানিবলৈ ইয়াত ক্লিক কৰক।</a>
 </p>
</div>
<br><br><br><br><br><br><br><br><br><br><br>
  <div id="akashdeep">

      <h1 class="heading">আকাশদ্বীপ</h1>
      <p class="content">
      অসম চৰকাৰৰ এম.এম.এ.ডি.ৱাই. আঁচনিৰ অধীনত এপিডিচিএলৰ প্ৰযোজ্য উপভোক্তা আধাৰৰ মাজত এল.ই.ডি. বাল্ব বিতৰণ কৰা হ'ব।
        আকাশদ্বীপ মোবাইল এপ্ হ’ল আঁচনিখন সাৰ্থকভাৱে আৰু স্বচ্ছতাৰে ৰূপায়ণ কৰাৰ বাবে  এপিডিচিএল-ৰ এক প্ৰয়াস।
      </p>
    </div>
    <br><br><br><br><br><br><br><br><br><br><br>
</div>
</div>
</template>

<style scoped="true">
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
  text-align: justify;
  line-height: 1.8rem;
  font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;
}
#vision{
  transition: 1s;
}
table{
  text-align: left !important;
}
.tableWidth{
  width: 500px;
}
@media (max-width: 576px) {
  .tableWidth{
    width: 340px;
  }
  .cntnt{
  box-shadow: none;
  }
}
</style>
<script>
export default {

}
</script>
